module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog2-927a9e38944bf987f44844921905b3c7.jpg";